/* src/app/private/components/hostel/delete-hostel/delete-hostel.component.scss */
/*# sourceMappingURL=delete-hostel.component.css.map */
